// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"94":"9608432e","206":"f2728204","563":"56a516ee","665":"8b45c525"}[chunkId] + ".chunk.css";
};